import { LoraMetadata } from "./lora-metadata.model";

export class Device {
  // COMMON
  _id?: string;
  name?: string;
  ref?: string;
  sku?: string;
  company?: any;
  project?: any;
  updatedAt?: Date;
  createdAt?: Date;
  transmission?: LoraMetadata[];
  gathersData?: boolean;
  deviceType?: string;
  status?: 'stock' | 'loaned' | 'returning' | 'under_review' | 'sold' | 'damaged' | 'workshop';
  lastSeenAt?: Date;
  // DataAcquisition
  loramac?: string;
  available?: boolean;
  concrete?: any;
  measurement?: any;
  deviceProfile?:any;
  battery?: number;
  // LoraGateway
  mac?: string;
  chirpstackMetadata?: any;
  version?: string;
  // SmartSensor
  uid?: string;
  busAddress?: number;

  // MiniPC
}

// TODO: CREATE INDIVIDUAL MODELS FOR EACH DEVICE TYPE ONLY WITH THEIR OWN FIELDS
// export class DataAcquisition extends Device {}
// export class LoraGateway extends Device {}
